import type { AttributionUser } from "../api/client";

function displayName(user: AttributionUser): string {
  const name = user.name?.trim();
  if (name) return name;
  return user.email.split("@")[0] || user.email;
}

export default function AttributionBadge({
  createdBy,
  compact = false,
  className = "",
}: {
  createdBy: AttributionUser | null | undefined;
  compact?: boolean;
  className?: string;
}) {
  if (!createdBy) return null;
  return (
    <span className={`creator-badge ${compact ? "compact" : ""} ${className}`.trim()}>
      Created by {displayName(createdBy)}
    </span>
  );
}
